import React from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'

export function DeleteSvg (props) {
  const size = props.size || 24
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path
        d='M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m3 0v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7M10 11v5M14 11v5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

DeleteSvg.propTypes = {
  size: PropTypes.number
}

class DeleteIcon extends React.Component {
  render () {
    return (
      <div className='flex flex-col items-center text-center' style={{ cursor: 'pointer', fontSize: '12px', textTransform: 'none' }}>
        <DeleteSvg />
        <MediaQuery minWidth={992}>
          <div className='pt-10'> {this.props.content || 'Delete'} </div>
        </MediaQuery>
      </div>
    )
  }
}

DeleteIcon.propTypes = {
  content: PropTypes.string
}

export default DeleteIcon
